document.addEventListener("DOMContentLoaded", function () {
  const customVariantPicker = document.querySelector(".custom-variant-picker");

  if (customVariantPicker) {
    const button = customVariantPicker.querySelector(".custom-variant-button");
    const variantList = customVariantPicker.querySelector(
      ".custom-variant-list"
    );
    const selectedVariantText = customVariantPicker.querySelector(
      ".selected-variant-text"
    );
    const variantItems = customVariantPicker.querySelectorAll(
      ".custom-variant-item"
    );

    // Toggle dropdown on button click
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      customVariantPicker.classList.toggle("open");
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (!customVariantPicker.contains(e.target)) {
        customVariantPicker.classList.remove("open");
      }
    });

    // Close dropdown on escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        customVariantPicker.classList.remove("open");
      }
    });

    const baseUrl = window.location.href.split("/products/")[0];

    // Handle variant selection
    variantItems.forEach((item) => {
      const variantId = item.getAttribute("data-variant-id");
      const variantText = item.textContent.trim();
      const isCurrentVariant = location.href.endsWith(variantId);

      if (isCurrentVariant) {
        item.classList.add("selected");
        selectedVariantText.textContent = variantText;
      }

      item.addEventListener("click", function () {
        selectedVariantText.textContent = variantText;
        customVariantPicker.classList.remove("open");
        if (!isCurrentVariant) {
          window.location.href = `${baseUrl}/products/${variantId}`;
        }
      });
    });
  }
});
